module.exports = "/_next/static/images/a6d13ab368986c72e428c3e38d8c4669-movie-poster.png";